import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { useUpdateQuestionnaireMutation, useGetQuestionnairesForVenturesAndLabelQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'MakeEsgReportsEditable',
  props: {
    selected: null
  },
  setup: function setup(__props) {
    var props = __props;
    var _useUpdateQuestionnai = useUpdateQuestionnaireMutation(),
      mutate = _useUpdateQuestionnai.mutate,
      onDone = _useUpdateQuestionnai.onDone,
      loadingUpdate = _useUpdateQuestionnai.loading;
    var inputs = computed(function () {
      return {
        ventureIds: props.selected.map(function (s) {
          return s.ventureId;
        }),
        label: 'ESG'
      };
    });
    var _useGetQuestionnaires = useGetQuestionnairesForVenturesAndLabelQuery(inputs),
      loadingRefetch = _useGetQuestionnaires.loading,
      refetch = _useGetQuestionnaires.refetch;
    var esgTableRef = ref(null);
    var selectedIds = ref([]);
    var sendNotification = ref(true);
    var loading = computed(function () {
      return loadingUpdate.value || loadingRefetch.value;
    });
    var handleReopenQuestionnaires = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(dialog) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Promise.all(selectedIds.value.map(function (id) {
                return mutate({
                  input: {
                    id: id,
                    isEditable: true,
                    doSendNotification: sendNotification.value
                  }
                });
              }));
            case 2:
              dialog.value = false;
              refetch();
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function handleReopenQuestionnaires(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    onDone(function () {
      window.$nuxt.$emit('userMsg');
    });
    return {
      __sfc: true,
      props: props,
      mutate: mutate,
      onDone: onDone,
      loadingUpdate: loadingUpdate,
      inputs: inputs,
      loadingRefetch: loadingRefetch,
      refetch: refetch,
      esgTableRef: esgTableRef,
      selectedIds: selectedIds,
      sendNotification: sendNotification,
      loading: loading,
      handleReopenQuestionnaires: handleReopenQuestionnaires
    };
  }
});